import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
	providedIn: 'root',
})
export class ToastAlert {
	constructor(private notificationComponente: ToastrService) {}

	toastSuccess(title: string, message: string) {
		this.notificationComponente.success(message, title);
	}

	toastFailure(title: string, message: string = '') {
		this.notificationComponente.error(message, title);
	}

	toastWarning(title: string, message: string) {
		this.notificationComponente.info(message, title);
	}
}
